import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import RoleUsers from './RoleUsers';

export default function Index(props) {
    const [roles, setRoles] = useState([]);
    const [ users, setUsers ] = useState([]);

    axios.get('http://localhost:5000/Roles/AllRoles')
        .then((response) => { 
            setRoles(response.data);
        })
        .catch((error) => { 
            console.log(error);
        })

    return (
        <React.Fragment>
            <h1>Roles</h1>

            

            <main>
           
                <span>
                    <Link to="/Admin/Roles/Create" className="btn btn-secondary">Create</Link>
                </span>
                <section>
                <table className="table table-sm table-bordered table-bordered">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Users</th>
                                <th>Update</th>
                                <th>Details</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                [...Array((roles.length))].map((e, i) =>
                                    <tr key={i}>
                                        <td>{roles[i]._id}</td>
                                        <td>{roles[i].name}</td>
                                        <td><RoleUsers id={roles[i].userId} /></td>
                                        <td><Link to={'/Admin/Roles/Update/'  + roles[i]._id}>Update</Link></td>
                                        <td><Link to={'/Admin/Roles/Details/' + roles[i]._id}>Details</Link></td>
                                        <td><Link to={'/Admin/Roles/Delete/' + roles[i]._id}>Delete</Link></td>
                                    </tr>
                                )
                            }
                           
                        </tbody>
                    </table>
                </section>
            </main>
        </React.Fragment>
    )
}